
import { CONNECT, SENDDATA, HANDLEDATA, DISCONNECT } from './mutation-types';
import constants from '@/constants';
import store from '@/store';

export default {

  [CONNECT](state, payload) {
    state.socket.isConnected = true;
    state.socket.scoketId = payload.scoketId;
    state.socket.channel = payload.channel;
  },
  [SENDDATA](state, payload) {
    state.socket.lastSentData = payload;
    state.socket.channel.send(payload.data);
  },
  [HANDLEDATA](state, payload) {
    const data = JSON.parse(payload);
    console.log('Payload reveived from WebSocket', data);
    state.socket.lastHandledData = data;
    const action = constants.socketActionMapping[data.action];
    console.log('Action Dispatched: ', action);
    store.dispatch(action, data.data);
  },
  [DISCONNECT](state) {
    state.socket.isConnected = false;
    state.socket.scoketId = null;
    state.socket.channel = null;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/socket/mutations.js